// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-buttonExtended {
  box-shadow: 0 0 6px 0 rgba(34, 34, 34, 0.15);
  display: flex;
  align-items: center;
  width: 100%;
  color: #222;
  position: relative;
  cursor: pointer;
  background-color: #fff;
  border-width: 0px;
  border-radius: 0px;
  font-size: 14px;
  margin: 0;
  padding: 10px 20px;
  text-align: left;
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
}
.srprs-buttonExtended:focus {
  outline: 0;
}
.srprs-buttonExtended:empty {
  display: none;
}
.srprs-buttonExtended.is-centered {
  text-align: center;
}
.srprs-buttonExtended.is-colored .wrapper-icon {
  padding-right: 15px;
}
.srprs-buttonExtended.is-colored .wrapper-right {
  padding-right: 15px;
}
.srprs-buttonExtended .wrapper-icon {
  padding-right: 15px;
}
.srprs-buttonExtended .wrapper-icon > .srprs-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  fill: currentColor;
}
.srprs-buttonExtended > .wrapper-inner {
  width: 100%;
  flex: 1 1 auto;
  line-height: 0;
  overflow: hidden;
}
.srprs-buttonExtended > .wrapper-inner > strong,
.srprs-buttonExtended > .wrapper-inner > span {
  display: block;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.srprs-buttonExtended > .wrapper-inner > strong {
  text-transform: uppercase;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
}
.srprs-buttonExtended > .wrapper-inner > span {
  font-size: 1em;
  font-weight: normal;
}
.srprs-buttonExtended .wrapper-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.srprs-buttonExtended .wrapper-right > i {
  display: block;
  width: 2.4em;
  height: 2.4em;
  line-height: 2.4em;
  color: #fff;
  border-radius: 50%;
  background-color: #e7e7e7;
  font-weight: bold;
  text-align: center;
  margin-right: 15px;
}
.srprs-buttonExtended .wrapper-right > i.is-active {
  background-color: var(--colorBackground);
}
.srprs-buttonExtended .wrapper-right > .srprs-icon {
  width: 0.8em;
  height: 0.8em;
  line-height: 0.8em;
}
.srprs-buttonExtended.is-dropdown {
  box-shadow: none;
  padding: 10px 0;
}
.srprs-buttonExtended.is-dropdown .wrapper-icon > .srprs-icon {
  width: 30px;
  height: 100%;
}
.srprs-buttonExtended.is-dropdown > .wrapper-inner > span {
  line-height: 12px;
  font-size: 12px;
}
.srprs-buttonExtended.is-dropdown > .wrapper-inner > strong {
  font-size: 15px;
}

@media screen and (min-width: 375px) {
  .srprs-buttonExtended {
    font-size: 16px;
    padding-top: 20px;
    padding-right: 30px;
    padding-bottom: 20px;
    padding-left: 30px;
  }
}
@media screen and (min-width: 640px) {
  .srprs-buttonExtended .wrapper-icon > .srprs-icon {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }
  .srprs-buttonExtended .wrapper-right > i {
    width: 2.25em;
    height: 2.25em;
    line-height: 2.25em;
  }
  .srprs-buttonExtended .wrapper-right > .srprs-icon {
    width: 1em;
    height: 1em;
    line-height: 1em;
  }
}
@media screen and (min-width: 768px) {
  .srprs-buttonExtended:not(.type-srprs-trips) .wrapper-icon {
    padding-right: 25px;
  }
  .srprs-buttonExtended .wrapper-right > i {
    margin-right: 25px;
  }
  .srprs-buttonExtended.is-dropdown .wrapper-inner > strong {
    font-size: 18px;
  }
  .srprs-buttonExtended.is-dropdown .wrapper-inner > span {
    line-height: 18px;
    font-size: 15px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-buttonExtended:not(.type-srprs-trips) .wrapper-icon {
    padding-right: 35px;
  }
  .srprs-buttonExtended .wrapper-right > i {
    margin-right: 35px;
  }
  .srprs-buttonExtended.is-dropdown .wrapper-icon > .srprs-icon {
    width: 38px;
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/ButtonExtended/ButtonExtended.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AApMA;EIGI,4CAAA;EJAF,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EAEE,iBAAA;EACA,kBAAA;EAEF,eAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EAEE,wBAAA;EACA,0BAAA;EACA,oCAAA;AAkMJ;AAhME;EACE,UAAA;AAkMJ;AAhME;EACE,aAAA;AAkMJ;AAhME;EACE,kBAAA;AAkMJ;AA9LI;EAEI,mBAAA;AA+LR;AA5LI;EAEI,mBAAA;AA6LR;AAxLE;EACE,mBAAA;AA0LJ;AAzLI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA2LN;AAxLE;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AA0LJ;AAzLI;;EAEE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2LN;AAzLI;EACE,yBAAA;EAEE,2IAAA;EACA,eAAA;AA0LR;AAvLI;EAEI,cAAA;EACA,mBAAA;AAwLR;AApLE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAsLJ;AArLI;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAuLN;AAtLM;EAEI,wCAAA;AAuLV;AAnLI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAqLN;AAjLE;EACE,gBAAA;EACA,eAAA;AAmLJ;AAjLI;EACE,WAAA;EACA,YAAA;AAmLN;AAhLM;EACE,iBAAA;EACA,eAAA;AAkLR;AAhLM;EACE,eAAA;AAkLR;;AC7SI;EDkIF;IACE,eAAA;IAEE,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EA8KJ;AACF;ACvTI;ED+IE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EA2KN;EAvKI;IACE,aAAA;IACA,cAAA;IACA,mBAAA;EAyKN;EAvKI;IACE,UAAA;IACA,WAAA;IACA,gBAAA;EAyKN;AACF;ACxUI;EDuKE;IACE,mBAAA;EAoKN;EAjKE;IACE,kBAAA;EAmKJ;EAhKI;IAEI,eAAA;EAiKR;EA9JI;IACE,iBAAA;IAEE,eAAA;EA+JR;AACF;ACvVI;EDiME;IACE,mBAAA;EAyJN;EAtJE;IACE,kBAAA;EAwJJ;EAtJE;IACE,WAAA;IACA,YAAA;EAwJJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-buttonExtended {\n  @include box-shadow(blur-s);\n\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: color(black);\n  position: relative;\n  cursor: pointer;\n  background-color: color(white);\n  border: {\n    width: 0px;\n    radius: 0px;\n  }\n  font-size: 14px;\n  margin: 0;\n  padding: 10px 20px;\n  text-align: left;\n  transition: {\n    property: all;\n    duration: 0.25s;\n    timing-function: ease-out;\n  }\n  &:focus {\n    outline: 0;\n  }\n  &:empty {\n    display: none;\n  }\n  &.is-centered {\n    text-align: center;\n  }\n\n  &.is-colored {\n    .wrapper-icon {\n      padding: {\n        right: 15px;\n      }\n    }\n    .wrapper-right {\n      padding: {\n        right: 15px;\n      }\n    }\n  }\n\n  .wrapper-icon {\n    padding-right: 15px;\n    > .srprs-icon {\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n      fill: currentColor;\n    }\n  }\n  > .wrapper-inner {\n    width: 100%;\n    flex: 1 1 auto;\n    line-height: 0;\n    overflow: hidden;\n    > strong,\n    > span {\n      display: block;\n      line-height: 20px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n    > strong {\n      text-transform: uppercase;\n      font: {\n        family: font(heading);\n        size: 16px;\n      }\n    }\n    > span {\n      font: {\n        size: 1em;\n        weight: normal;\n      }\n    }\n  }\n  .wrapper-right {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    > i {\n      display: block;\n      width: 2.4em;\n      height: 2.4em;\n      line-height: 2.4em;\n      color: color(white);\n      border-radius: 50%;\n      background-color: color(grey-light);\n      font-weight: bold;\n      text-align: center;\n      margin-right: 15px;\n      &.is-active {\n        background: {\n          color: var(--colorBackground);\n        }\n      }\n    }\n    > .srprs-icon {\n      width: 0.8em;\n      height: 0.8em;\n      line-height: 0.8em;\n    }\n  }\n\n  &.is-dropdown {\n    box-shadow: none;\n    padding: 10px 0;\n\n    .wrapper-icon > .srprs-icon {\n      width: 30px;\n      height: 100%;\n    }\n    > .wrapper-inner {\n      > span {\n        line-height: 12px;\n        font-size: 12px;\n      }\n      > strong {\n        font-size: 15px;\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-buttonExtended {\n    font-size: 16px;\n    padding: {\n      top: 20px;\n      right: 30px;\n      bottom: 20px;\n      left: 30px;\n    }\n  }\n}\n@include breakpoint(mobile-landscape) {\n  .srprs-buttonExtended {\n    .wrapper-icon {\n      > .srprs-icon {\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n      }\n    }\n    .wrapper-right {\n      > i {\n        width: 2.25em;\n        height: 2.25em;\n        line-height: 2.25em;\n      }\n      > .srprs-icon {\n        width: 1em;\n        height: 1em;\n        line-height: 1em;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-buttonExtended {\n    &:not(.type-srprs-trips) {\n      .wrapper-icon {\n        padding-right: 25px;\n      }\n    }\n    .wrapper-right > i {\n      margin-right: 25px;\n    }\n    &.is-dropdown .wrapper-inner {\n      > strong {\n        font: {\n          size: 18px;\n        }\n      }\n      > span {\n        line-height: 18px;\n        font: {\n          size: 15px;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-buttonExtended {\n    &:not(.type-srprs-trips) {\n      .wrapper-icon {\n        padding-right: 35px;\n      }\n    }\n    .wrapper-right > i {\n      margin-right: 35px;\n    }\n    &.is-dropdown .wrapper-icon > .srprs-icon {\n      width: 38px;\n      height: 100%;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
